import React from "react";
import styled from "styled-components";
import ImgAtom from "../../components/atoms/ImgAtom";

const AgreementsHeaderWrap = styled.div`
  border-bottom: 1px solid #e5e5e5;
  display: block;
`;
const AgreementsHeaderBox = styled.div`
  width: 90%;
  border: 0px;
  border-radius: 0px;
  max-width: 1160px;
  height: 60px;
  margin: 0 auto;
  text-align: center;
`;
const AgreementsHeaderLeft = styled.div`
  float: left;
  padding: 19px 0 0 0;
`;

const AgreementsHeaderRight = styled.div`
  float: right;
  padding: 13px 0 0 0;
`;

const LanguageList = styled.li`
  float: right;
  padding: 13px 0 0 0;
  font-size: 14px;
  color: #1e1e1e;
`;

export default function AgreementsHeader() {
  return (
    <AgreementsHeaderWrap>
      <AgreementsHeaderBox>
        <AgreementsHeaderLeft>
          <ImgAtom
            src="../images/logo.png"
            imgwidth="135px"
            cursor="pointer"
            padding="0"
          />
        </AgreementsHeaderLeft>
        <AgreementsHeaderRight>
          <ul>
            <LanguageList>KOR</LanguageList>
          </ul>
        </AgreementsHeaderRight>
      </AgreementsHeaderBox>
    </AgreementsHeaderWrap>
  );
}
